import React from 'react';

import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';

import type { WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core';
import styles from './styles';

import type ProviderStore from 'connect/web/src/stores/provider-store';

import { Close as CloseIcon } from '@material-ui/icons';
import type PolicyDialogStore from '../../stores/policy-dialog-store';
import { PolicyType } from '../../stores/policy-dialog-store';

import {
  Dialog,
  IconButton,
  DialogContent as MuiDialogContent,
  DialogTitle as MuiDialogTitle
} from '@material-ui/core';

interface IProps extends WithStyles<typeof styles> {
  providerStore?: ProviderStore;
  policyDialogStore?: PolicyDialogStore;
}

@inject('providerStore', 'policyDialogStore')
@observer
class PolicyDialog extends React.Component<IProps> {
  render() {
    const { classes, providerStore, policyDialogStore } = this.props;
    const { open, close } = policyDialogStore!;

    const { privacyPolicy, termsAndConditions } = providerStore!;
    const html = { __html: this.isPrivacyPolicy ? privacyPolicy : termsAndConditions };

    return (
      <Dialog open={open} onClose={close}>
        <MuiDialogTitle disableTypography={true}>
          <div className={classes.termsTitle}>
            <span>{this.title}</span>
            <IconButton onClick={close}>
              <CloseIcon />
            </IconButton>
          </div>
        </MuiDialogTitle>
        <MuiDialogContent>
          <div className={classes.policy} dangerouslySetInnerHTML={html} />
        </MuiDialogContent>
      </Dialog>
    );
  }

  @computed
  private get isPrivacyPolicy(): boolean {
    const { mode } = this.props.policyDialogStore!;
    return mode === PolicyType.Privacy;
  }

  @computed
  private get title(): string {
    return this.isPrivacyPolicy ? 'Privacy Policy' : 'Terms And Conditions';
  }
}

export default withStyles(styles)(PolicyDialog);
